import React from 'react';


function CodeExperience() {
  return (
    <div className="wrapper code-experience">
      <div className="container-fluid border-bottom-dashed pt-5">
        <h1 className="font-weight-bolder underscore">Our<br />Services</h1>
        <div className="row justify-content-center align-items-center p-3">
          <div className="col-12 col-md-7 order-2 order-md-1 p-2">
            <div className="d-inline d-md-flex mb-3">
              <div className="d-flex align-items-center px-md-4">
                <img src="/assets/ai-machine-learning.png" style={{ width: 90 }} alt=" " />
                <div className="d-inline px-4 d-md-none">
                  <h4 className="font-weight-bolder">
                    Artificial Intelligence/<br />Machine Learning
                  </h4>
                </div>
              </div>
              <div>
                <h4 className="font-weight-bolder d-none d-md-block">
                  Artificial Intelligence/Machine Learning
                </h4>
                <div className="display-6 font-weight-light my-5 my-md-0">
                  We harness the power of AI and machine learning to deliver outcomes that make the world a better place for everyone.
                </div>
              </div>
            </div>
            <div className="d-inline d-md-flex mb-3">
              <div className="d-flex align-items-center px-md-4">
                <img src="/assets/application-programming-int.png" style={{ width: 90 }} alt=" " />
                <div className="d-inline px-4 d-md-none">
                  <h4 className="font-weight-bolder ">
                    Application Programming Interfaces
                  </h4>
                </div>
              </div>
              <div>
                <h4 className="font-weight-bolder d-none d-md-block">
                  Application Programming Interfaces
                </h4>
                <div className="display-6 font-weight-light my-5 my-md-0">
                  We build scalable and secure APIs that connect to any device, machine or software.
                </div>
              </div>
            </div>
            <div className="d-inline d-md-flex mb-3">
              <div className="px-md-4 d-flex align-items-center">
                <img src="/assets/human-machine-interfaces.png" style={{ width: 90 }} alt=" " className="human-machine" />
                <div className="d-inline px-4 d-md-none">
                  <h4 className="font-weight-bolder">
                    Human Machine Interfaces
                  </h4>
                </div>
              </div>
              <div className="pl-1">
                <h4 className="font-weight-bolder d-none d-md-block">
                  Human Machine Interfaces
                </h4>
                <div className="display-6 font-weight-light my-5 my-md-0">
                  From versatile touchscreens to intuitive joystick control, we create interfaces for humans to interact with machines.
                </div>
              </div>
            </div>
            <div className="d-inline d-md-flex mb-3">
              <div className="d-flex align-items-center px-md-4">
                <img src="/assets/internet-of-things.png" style={{ width: 90 }} alt=" " />
                <div className="d-inline px-4 d-md-none">
                  <h4 className="font-weight-bolder">
                    Internet of Things
                  </h4>
                </div>
              </div>
              <div>
                <h4 className="font-weight-bolder d-none d-md-block">
                  Internet of Things
                </h4>
                <div className="display-6 font-weight-light my-5 my-md-0">
                  We improve interoperability, automation, control and data collection by building bridges to get machines talking to each other.
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-5 text-center order-1 order-md-2 p-2 d-none d-md-block">
            <img alt=" " src="/assets/robot.png" className="img-fluid robot" />
          </div>
          <div className="col-12 col-md-5 text-center order-1 order-md-2 p-2 d-md-none d-block mb-5">
            <img alt=" " src="/assets/robot-mobile.jpg" className="img-fluid" />
          </div>
        </div>
        {/*-------------------------------------------------------------*/}
        <div className="row justify-content-center align-items-center pb-8">
          <div className="col-12 col-md-5 p-2 text-center">
            <img src="/assets/mobile.png" alt=" " className="img-fluid mobile d-none d-md-block " />
          </div>
          <div className="col-12 col-md-7 p-2">

            <div className="d-inline d-md-flex mb-3">
              <div className="px-md-4 d-flex align-items-center">
                <img src="/assets/webapps.png" alt=" " style={{ width: 90 }} />
                <div className="d-inline px-4 d-md-none">
                  <h4 className="font-weight-bolder">Web Apps & Marketplaces</h4>
                </div>
              </div>
              <div>
                <h4 className="font-weight-bolder d-none d-md-block">Web Apps & Marketplaces</h4>
                <div className="display-6 font-weight-light my-5 my-md-0">
                  We take websites to the next level, creating cross-platform solutions that work seamlessly on all browsers and adapted to specific industries.
                </div>
              </div>
            </div>


            <div className="d-inline d-md-flex mb-3">
              <div className="px-md-4 d-flex align-items-center">
                <img src="/assets/hybrid-apps.png" alt=" " style={{ width: 90 }} />
                <h4 className="d-inline px-4 d-md-none font-weight-bolder">Hybrid Apps</h4>
              </div>
              <div>
                <h4 className="font-weight-bolder d-none d-md-block">Hybrid Apps</h4>
                <div className="display-6 font-weight-light my-5 my-md-0">
                  We develop unique codebases for hybrid applications with greater efficiency and scalability across all mobile devices.
                </div>
              </div>
            </div>

            <div className="d-inline d-md-flex mb-3">
              <div className="d-flex align-items-center px-md-4">
                <img src="/assets/augmented-virtual-reality.png" alt=" " style={{ width: 90 }} />
                <h4 className="d-inline px-4 d-md-none font-weight-bolder">Augmented & Virtual Reality</h4>
              </div>
              <div>
                <h4 className="font-weight-bolder d-none d-md-block">Augmented & Virtual Reality</h4>
                <div className="display-6 font-weight-light my-5 my-md-0">
                  We blend the real and digital worlds to spark collaboration and interactivity across any industry through the power of enriched visual media.
                </div>
              </div>
            </div>

            <div className="d-inline d-md-flex mb-3">
              <div className="d-flex align-items-center px-md-4">
                <img src="/assets/blockchain.png" alt=" " style={{ width: 90 }} />
                <div className="d-inline px-4 d-md-none">
                  <h4 className="font-weight-bolder">Distributed Ledger Technology</h4>
                </div>
              </div>
              <div className="ml-1">
                <h4 className="font-weight-bolder d-none d-md-block">Blockchain & Distributed Ledger Technology</h4>
                <div className="display-6 font-weight-light my-5 my-md-0">
                  We help businesses improve transparency and data protection through DLT solutions.
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default CodeExperience;

